import { useEffect, useState } from 'react';
import { Modal, Loading, Button, SvgIcon, Upload } from '@/components';
import { beforeUpload, uuid, getFileExtension } from '@/shared/utils/tools';
import Message from 'rc-message';
import { apiService } from '@/shared/apiService';
import './GPAppUploadModal.less';
export interface GPAppUploadProps {
  visible: boolean;
  closeLabel: string;
  onClose?: () => void;
  handleUpdate: () => void;
}

export interface Error {
  code: number,
   message: string
}

export function GPAppUploadModal(
  props: GPAppUploadProps & React.HTMLAttributes<HTMLDivElement>,
) {
  const { visible, onClose, closeLabel, handleUpdate } = props;
  const [file, setFile] = useState<File>();
  const [appName, setAppName] = useState<string>('');
  const [appPkgName, setAppPkgName] = useState<string>('');
  const [fileName, setFileName] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string>('');

  useEffect(() => {
    setFileName('');
    setFile(undefined);
  }, [visible])

  const uploadImage = (file: File) => {
    const newName = uuid() + getFileExtension(file.name);
    const newFile = new File([file], newName, {
      type: file.type,
    });
    setFile(newFile);
    setFileName(file.name);
  };

  const uploadGPApp = async () => {
    if (!file || !appName || !appPkgName) {
      Message.error({ content: '请填写完整！' });
    } else {
      try {
        const data = await apiService.gpAppUpload(appName, appPkgName, file);
        if (data) {
          Message.success({ content: '上传成功！' });
          handleUpdate && handleUpdate()
          onClose && onClose();
        }
      }catch(e: any) {
        setErrorMessage(e.message)
      }
    }
  };

  const handInputChange = (e: any, type: string) => {
    const value = e.target.value;
    switch (type) {
      case 'appName':
        setAppName(value);
        break;
      case 'appPkgName':
        setAppPkgName(value);
        break;
      default:
        break;
    }
  };
  return (
    <Modal visible={visible} className="GP-upload-modal" destroyOnClose>
      <div className="title">{window.trans('my-app')}</div>
      <div className="upload_gp_item">
        <span className="item_title">应用名称</span>
        <input
          className="item_content"
          name="appName"
          onChange={(e) => handInputChange(e, 'appName')}
        ></input>
      </div>
      <div className="upload_gp_item">
        <span className="item_title">应用包名</span>
        <input
          className="item_content"
          name="appPkgName"
          onChange={(e) => handInputChange(e, 'appPkgName')}
        ></input>
      </div>
      <div className="upload_gp_item">
        <span className="item_title">应用APK</span>
        {/* <input className="item_content" type="file" name="apkFile"></input> */}
        <div className="item_content">
          <Upload
            className="custom-upload-btn"
            // onChange={uploadImage}
            customRequest={(options: any) => {
              uploadImage(options?.file);
            }}
          >
            <span>{fileName}</span>
            <Button className="uploadButton">+ 上传 </Button>
          </Upload>
        </div>
      </div>

      <span className="desc">
        请上传带有GooglePlay的地址URL且确保上架状态的应用APK
      </span>
      <span className='error'>{ errorMessage }</span>
      <section className="opt-box flex-center">
        <Button
          className="back"
          onClick={() => {
            onClose && onClose();
          }}
        >
          返回
        </Button>
        <Button
          type="primary"
          className={'save'}
          onClick={() => {
            uploadGPApp();
          }}
        >
          保存小部件
        </Button>
      </section>
    </Modal>
  );
}
